import "../assets/styles/About.css";
import Img8 from "../assets/images/Gallery/img8.jpg";
const About = () => {
  return (
    <>
      <div className="aboutBody">
        <div className="aboutSection">
          <div className="aboutContainer">
            <div className="aboutContent-section">
              <div className="aboutTitle">About Us</div>
              <div className="aboutContent">
                <h3>We Produce Champions</h3>
                <p>
                  A football academy is a facility setup to deliver young
                  footballers. The football academy provodes professional with
                  an established football excellence and education programme
                  that will not only attract, develop and retain quality young
                  players but also support club in meeting core special
                  responsibilities.{" "}
                </p>
              </div>
              <div className="aboutSocial">
                <a href="https://www.facebook.com/people/Little-Champ-Football-Academy-Erode/100086524118479/">
                  <i className="fa fa-facebook-square"></i>
                </a>
                <a href="https://www.facebook.com/people/Little-Champ-Football-Academy-Erode/100086524118479/">
                  <i className="fa fa-instagram"></i>
                </a>
                <a href="https://wa.me/917868040150?text=Hello+Little+Champ%E2%9A%BD%2C%0D%0A">
                  <i className="fa fa-whatsapp"></i>
                </a>
                <a href="https://www.youtube.com/@littlechampfootballacademy3630">
                  <i className="fa fa-youtube"></i>
                </a>
              </div>
            </div>
            <div className="aboutImage-section">
              <img src={Img8} alt="ImageAbout"></img>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
